import React from "react";
import nextId from "react-id-generator";
import { useHistory } from "react-router";
import Loading from "../../loading/Loading";
import { getUsersBlock } from "../../services/getAPIs";
import moment from "moment-timezone";
import "./transaction.style.scss";
import UploadBlock from "./UploadBlock/UploadBlock";
import { BlockMachine } from "../Context/Context";
import SearchHash from "../Common/SearchHash/SearchHash";
export default function Transaction({ setHideHeader }) {
  const history = useHistory();
  const [loading, setLoading] = React.useState(true);
  const [userBlockList, setUserBlockList] = React.useState([]);
  const context = React.useContext(BlockMachine);
  const { loggedIn } = context;
  const [enableModal, setEnableModal] = React.useState(false);
  const setUpUserBlockList = async () => {
    let res;
    try {
      res = await getUsersBlock();
      if (res.data.success) {
        setUserBlockList(res.data.data);
      } else {
        setUserBlockList([]);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setUserBlockList([]);
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setUpUserBlockList();
    setHideHeader();
  }, []);
  React.useEffect(() => {
    if (loggedIn === null) return;
    if (!loggedIn) {
      history.push("/home");
    }
  }, [loggedIn]);
  return (
    <div className="transaction-main">
      <div className="t-m-header">
        <h3>Transactions</h3>
        <div className="t-m-search-wrapper">
          <SearchHash />

        </div>
      </div>
          <div className="ethereum-info">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
      <UploadBlock setUpUserBlockList={setUpUserBlockList} />
      <div className="t-m-body">
        <div className="t-m-table">
          <div className="t-m-table-page">
            <div className="table-page-left">
              <h4>More than {userBlockList.length} transaction </h4>
            </div>
          </div>
          <div className="t-m-table-header">
            {header.map((obj) => (
              <h6 key={obj.keyId}>{obj.name}</h6>
            ))}
          </div>
          <div className="t-m-table-body">
            {loading ? (
              <Loading />
            ) : (
              userBlockList.map((obj, num) => (
                <div
                  onClick={() => history.push(`/home/transaction/${obj.hash}`)}
                  className="t-m-table-row"
                >
                  <h6>{num + 1}</h6>
                  <h6>{obj.hash}</h6>
                  <h6>{moment(obj.createdOn).format("DD-MM-YYYY hh:mm a")}</h6>
                  <h6>{obj.previousHash}</h6>
                  <h6>{obj.merkleRoot}</h6>
                </div>
              ))
            )}
          </div>
          <div className="t-m-table-footer"></div>
        </div>
      </div>
    </div>
  );
}
const header = [
  { keyId: nextId(), name: "#", id: "num" },
  { keyId: nextId(), name: "Txn Hash", id: "hash" },
  { keyId: nextId(), name: "Created On", id: "age" },
  { keyId: nextId(), name: "From", id: "from" },
  { keyId: nextId(), name: "Value", id: "value" },
];
